import { cloudFunction } from 'services/parse';

export const createTag = ({ value, enValue, isPublic }: { value: string; enValue: string; isPublic: boolean }) => {
  return cloudFunction('createAvailableTag', { value, enValue, isPublic });
};

export const deleteTag = (id: string) => {
  return cloudFunction('deleteAvailableTag', { id });
};

export const updateTag = (data: Record<string, any>) => {
  return cloudFunction('updateAvailableTag', data);
};

export const fetchTags = () => {
  return cloudFunction('fetchAllAvailableTags', {});
};

export const fetchAvailableTagDetails = (id: string) => {
  return cloudFunction('fetchAllAvailableTagDetail', { id });
};

export const updateTagImage = (id: string, image: Parse.File) => {
  return cloudFunction('updateAvailableTagIcon', { id, icon: image });
};
